import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}dashboard`;

export function getStats(params) {
  return axios({ method: "GET", url: `${URL}/stats`, params });
}

export function getGrandTotal(params) {
  return axios({ method: "GET", url: `${URL}/grand_total`, params });
}

export function getGradeOrg(type, pageNumber, limit) {
  return axios.get(`${URL}/grade_org`, {
    params: {
      type,
      limit,
      page: pageNumber,
    }
  });
}

export function findInactiveOrg(queryParams) {
  return axios.post(`${URL}/find_inactive_org`, queryParams);
}

export function findProductiveOrg(queryParams) {
  return axios.post(`${URL}/find_productive_org`, queryParams);
}

export function getDonationFavAmount() {
  return axios.get(`${URL}/get_favorite_donation_amount`);
}

export function getTotalDonation(type) {
  return axios.get(`${URL}/get_total_donation/${type}`);
}

export function getTopOrgDonation() {
  return axios.get(`${URL}/get_top_org_by_donation`);
}

export function getOrgTotalDonation(params) {
  return axios.get(`${URL}/get_total_donation_org`, {
    params
  });
}

export function getTopOrgbyDonor() {
  return axios.get(`${URL}/get_top_org_by_donor`);
}

export function getTotalDonor(params) {
  return axios.get(`${URL}/get_total_donor_count`, { params });
}

export function getTotalDonationCount() {
  return axios.get(`${URL}/get_total_donation_count`);
}

export function getDonationYearTarget() {
  return axios.get(`${URL}/get_donation_year_target`);
}

export function getDashboardListOrgAll(params) {
  return axios({ method: "GET", url: `${URL}/get_dashboard_list_all`, params });
}
